import React from 'react';

/**
 * SKP HOPO – Touch Kiosk
 * Renders the self-contained kiosk HTML inside a full-screen iframe.
 * The HTML is served from /admin/skp_kiosk.html (copied from Client/public during build).
 * Faithful replica of the legacy ASP.NET kiosk (csgkiosk.cz/touch/skphp3971).
 */
const SkpKiosk = () => {
    return (
        <iframe
            src="/admin/skp_kiosk.html"
            title="SKP HOPO Kiosk"
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100vw',
                height: '100vh',
                border: 'none',
                display: 'block',
                zIndex: 9999,
                background: '#000',
            }}
        />
    );
};

export default SkpKiosk;
